import React from 'react';
import { ImageBackground, StyleSheet, View } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import PropTypes from 'prop-types';

import { Theme } from '@constants';

import { isWebkit, isX1 } from '../../../helpers/Platform';
import { ShowDetailsPageHeader } from '../../onDemand/components/ShowDetailsPageHeader';

const PDPBackground = ({ data }) => (
  <>
    <View style={styles.backgroundGradientWrapper}>
      <LinearGradient
        angle={270}
        colors={[
          Theme.gradients.vodBackground.start,
          Theme.gradients.vodBackground.start,
          Theme.gradients.vodBackground.start,
          Theme.gradients.vodBackground.end,
          Theme.gradients.vodBackground.end,
          Theme.gradients.vodBackground.end,
        ]}
        style={styles.linearGradient}
        useAngle
      >
        <LinearGradient
          useAngle
          angle={270}
          colors={[
            Theme.gradients.vodBackground.start,
            Theme.gradients.vodBackground.start,
            Theme.gradients.vodBackground.end,
            Theme.gradients.vodBackground.end,
            Theme.gradients.vodBackground.end,
          ]}
          style={styles.linearGradientDown}
        />
      </LinearGradient>
    </View>
    <View style={styles.backgroundWrapper}>
      <ImageBackground
        resizeMode={'cover'}
        source={
          data
            ? {
                uri: data.wallpaper,
              }
            : null
        }
        style={styles.headerBackground}
        testID={'pdp_background'}
      />
    </View>
  </>
);

export const PictureDetailedPageHeader = ({
  onFocus,
  onBlur,
  testID,
  nextFocusDown,
  nextFocusLeft,
  nextFocusRight,
  nextFocusUp,
  data,
  upNextShow,
}) => (
  <View style={styles.header}>
    <PDPBackground data={data} />
    <View style={styles.headerSection}>
      <ShowDetailsPageHeader
        data={data}
        nextFocusDown={nextFocusDown}
        nextFocusLeft={nextFocusLeft}
        nextFocusRight={nextFocusRight}
        nextFocusUp={nextFocusUp}
        testID={testID}
        upNextShow={upNextShow}
        onBlur={onBlur}
        onFocus={onFocus}
      />
    </View>
  </View>
);

PictureDetailedPageHeader.propTypes = {
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  testID: PropTypes.string,
  nextFocusDown: PropTypes.oneOfType([PropTypes.object, PropTypes.element, () => null]),
  nextFocusLeft: PropTypes.oneOfType([PropTypes.object, PropTypes.element, () => null]),
  nextFocusRight: PropTypes.oneOfType([PropTypes.object, PropTypes.element, () => null]),
  nextFocusUp: PropTypes.oneOfType([PropTypes.object, PropTypes.element, () => null]),
  data: PropTypes.object,
  upNextShow: PropTypes.object,
};

PictureDetailedPageHeader.defaultProps = {
  onFocus: () => {},
  onBlur: () => {},
  testID: null,
  nextFocusDown: null,
  nextFocusLeft: null,
  nextFocusRight: null,
  nextFocusUp: null,
  data: null,
  upNextShow: null,
};

const styles = StyleSheet.create({
  backgroundGradientWrapper: {
    elevation: 1,
    height: Theme.appHeight,
    left: 0,
    position: isX1 || isWebkit ? 'fixed' : 'absolute',
    top: 0,
    width: Theme.appWidth,
    zIndex: 1,
  },
  backgroundWrapper: {
    elevation: 1,
    height: Theme.appHeight,
    left: 0,
    position: isX1 || isWebkit ? 'fixed' : 'absolute',
    top: 0,
    width: Theme.appWidth,
    zIndex: 0,
  },
  header: {
    flex: 1,
    height: Theme.px(972),
    width: Theme.appWidth,
  },
  headerBackground: {
    height: Theme.appHeight,
    width: Theme.appWidth,
  },
  headerSection: {
    elevation: 1,
    paddingLeft: Theme.px(90),
    paddingTop: Theme.px(109),
    position: isX1 || isWebkit ? 'fixed' : 'absolute',
    zIndex: 2,
  },
  linearGradient: {
    height: Theme.appHeight,
    justifyContent: 'flex-end',
    width: Theme.appWidth,
  },
  linearGradientDown: {
    height: Theme.px(110),
    width: Theme.appWidth,
  },
});
